{
  "familyId": "GET-PROC-BTW",
  "questions": [
    {
      "id": "GET-PROC-BTW-001",
      "familyId": "GET-PROC-BTW",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_btw_excl",
      "questionType": "multiple_choice",
      "question": "Een product kost €121 inclusief 21% BTW. Wat is de prijs exclusief BTW?",
      "context": null,
      "options": ["€100", "€99,79", "€96", "€101,21"],
      "correctAnswer": 0,
      "conceptId": "vat_exclusive_basic",
      "variantIndex": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "BTW exclusief berekenen",
            "content": "Prijs incl. BTW = prijs excl. × 1,21 (bij 21% BTW). Dus: prijs excl. = prijs incl. ÷ 1,21. Voorbeeld: €121 ÷ 1,21 = €100."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is €100. Inclusief 21% BTW betekent: prijs excl. × 1,21 = €121. Dus prijs excl. = €121 ÷ 1,21 = €100. Controleer: €100 × 1,21 = €121. ✓",
        "distractorExplanations": {
          "0": "Goed! €121 ÷ 1,21 = €100. Inclusief BTW = excl. × 1,21, dus excl. = incl. ÷ 1,21.",
          "1": "€99,79 is fout. Je hebt misschien €121 − 21% van €121 = €121 − €25,41 ≈ €95,59 berekend. Maar je moet delen door 1,21: €121 ÷ 1,21 = €100.",
          "2": "€96 is fout. Je hebt misschien €121 − 25 = €96 berekend. Maar de BTW is 21% van de excl. prijs, niet een vast bedrag. €121 ÷ 1,21 = €100.",
          "3": "€101,21 is fout. Je hebt misschien €100 + €1,21 = €101,21 berekend. Maar de BTW is al in €121 inbegrepen. €121 ÷ 1,21 = €100."
        }
      }
    },
    {
      "id": "GET-PROC-BTW-002",
      "familyId": "GET-PROC-BTW",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_btw_excl",
      "questionType": "multiple_choice",
      "question": "Een dienst kost €60,50 inclusief 21% BTW. Hoeveel is het BTW-bedrag?",
      "context": null,
      "options": ["€10,50", "€12,71", "€50", "€21"],
      "correctAnswer": 0,
      "conceptId": "vat_amount_calculation",
      "variantIndex": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "BTW-bedrag berekenen",
            "content": "Stap 1: prijs excl. = €60,50 ÷ 1,21 = €50. Stap 2: BTW = incl. − excl. = €60,50 − €50 = €10,50. Of: BTW = excl. × 0,21 = €50 × 0,21 = €10,50."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is €10,50. Stap 1: prijs excl. BTW = €60,50 ÷ 1,21 = €50. Stap 2: BTW = €60,50 − €50 = €10,50. Of: BTW = €50 × 0,21 = €10,50.",
        "distractorExplanations": {
          "0": "Goed! Excl. = €60,50 ÷ 1,21 = €50. BTW = €60,50 − €50 = €10,50.",
          "1": "€12,71 is fout. Je hebt misschien 21% van €60,50 = €12,71 berekend. Maar 21% BTW is van de excl. prijs, niet van de incl. prijs. Excl. = €60,50 ÷ 1,21 = €50, BTW = €50 × 0,21 = €10,50.",
          "2": "€50 is de prijs excl. BTW, niet het BTW-bedrag. BTW = incl. − excl. = €60,50 − €50 = €10,50.",
          "3": "€21 is fout. Je hebt het BTW-percentage (21%) als bedrag genomen. Maar de BTW is 21% van de excl. prijs: €50 × 0,21 = €10,50."
        }
      }
    },
    {
      "id": "GET-PROC-BTW-003",
      "familyId": "GET-PROC-BTW",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_btw_excl",
      "questionType": "multiple_choice",
      "question": "Een factuur vermeldt €242 inclusief 21% BTW. Wat is de prijs exclusief BTW?",
      "context": null,
      "options": ["€200", "€220,79", "€192,18", "€221"],
      "correctAnswer": 0,
      "conceptId": "vat_exclusive_invoice",
      "variantIndex": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "BTW exclusief berekenen",
            "content": "Prijs excl. = prijs incl. ÷ 1,21. €242 ÷ 1,21 = €200. Controleer: €200 × 1,21 = €242. ✓"
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is €200. Inclusief 21% BTW: prijs excl. × 1,21 = €242. Dus prijs excl. = €242 ÷ 1,21 = €200. Controleer: €200 × 1,21 = €242. ✓",
        "distractorExplanations": {
          "0": "Goed! €242 ÷ 1,21 = €200. Controleer: €200 × 1,21 = €242. ✓",
          "1": "€220,79 is fout. Je hebt misschien €242 − 21% van €242 = €242 − €50,82 ≈ €191,18 berekend (of een afrondingsfout). Deel door 1,21: €242 ÷ 1,21 = €200.",
          "2": "€192,18 is fout. Je hebt misschien een verkeerde factor gebruikt. De juiste factor is 1,21 (voor 21% BTW): €242 ÷ 1,21 = €200.",
          "3": "€221 is fout. Je hebt misschien €242 − 21 = €221 berekend. Maar €21 is niet de BTW (de BTW is 21% van de excl. prijs). €242 ÷ 1,21 = €200."
        }
      }
    }
  ]
}
